import React from 'react';
import { Drawer as DrawerAntd } from 'antd';

const Drawer = ({
  className,
  size,
  visible,
  title,
  onClose,
  children,
  footer
}) => {
  const width =
    size && (size.includes('%') || size.includes('px')) ? size : undefined;
  const sizeClass = size && !width ? size : null;

  return (
    <DrawerAntd
      visible={visible}
      className={`gx-drawer-form ${className} ${sizeClass}`}
      width={width}
      title={title}
      onClose={onClose}
      bodyStyle={footer ? { paddingBottom: 80 } : null}
    >
      {children}
      {footer ? (
        <div
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right'
          }}
        >
          {footer}
        </div>
      ) : null}
    </DrawerAntd>
  );
};

export default Drawer;
